import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import CustomersTable from "../components/CustomersTable";
import { useGetAllBrandCustomersMutation } from "redux/loyalty/loyalty-service";

const LoyaltyCustomers = () => {
  const [searchTerm, setSearch] = useState("");
  const [customers, setCustomers] = useState({
    data: [],
    totalrecords: 0,
    currentPage: 1,
  });
  const [getAllBrandCustomers] = useGetAllBrandCustomersMutation();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  async function fetchData(page) {
    const { data } = await getAllBrandCustomers({
      page: page,
    });
    if (data?.success === 1 && data?.data?.users?.users?.length > 0) {
      handleCustomerState("data", data?.data?.users?.users);
      handleCustomerState("totalrecords", data?.data?.users?.count);
    } else {
      handleCustomerState("data", []);
      handleCustomerState("totalrecords", 0);
    }
  }

  const handleSearch = (e) => setSearch(e.target.value);

  const handlePageChange = (page) => {
    handleCustomerState("currentPage", page);
    fetchData(page);
  };

  useEffect(() => {
    handleCustomerState("currentPage", 1);
    fetchData(1);
  }, [searchTerm]);

  const handleCustomerState = (key, val) => {
    setCustomers((prevState) => ({
      ...prevState,
      [key]: val,
    }));
  };

  return (
    <Spin spinning={isLoading}>
      <CustomersTable
        {...{
          customers,
          handlePageChange,
          handleSearch,
          searchTerm,
          onRefresh: () => fetchData(customers.currentPage || 1),
        }}
      />
    </Spin>
  );
};
export default LoyaltyCustomers;
